import { getConfig } from './config'

export type HomologationCreate = {
  labName: string
  state: string
  files: string[]
}

export const create = async (params: HomologationCreate): Promise<void> => {
  const config = getConfig()

  await config.axios.post(
    `${config.API_URL}/homologations`,
    params
  )
}
